import { render, staticRenderFns } from "./PaymentFailureModal.vue?vue&type=template&id=9c0076c0&scoped=true&"
import script from "./PaymentFailureModal.vue?vue&type=script&lang=js&"
export * from "./PaymentFailureModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFailureModal.vue?vue&type=style&index=0&id=9c0076c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0076c0",
  null
  
)

export default component.exports